import {
  GET_LAW_EXPENSES,
  GET_LAW_EXPENSE,
  CREATE_LAW_EXPENSE,
  UPDATE_LAW_EXPENSE,
  DELETE_LAW_EXPENSE
} from '../actions/lawExpenseActions';

const initialState = {
  expenses: [],
  expense: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const lawExpenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LAW_EXPENSES:
      return {
        ...state,
        expenses: action.payload.expenses || action.payload,
        numberOfPages: action.payload.totalPages || 0,
        currentPage: action.payload.currentPage || 1,
        isLoading: false
      };

    case GET_LAW_EXPENSE:
      return {
        ...state,
        expense: action.payload,
        isLoading: false
      };

    case CREATE_LAW_EXPENSE:
      return {
        ...state,
        expenses: [action.payload, ...state.expenses]
      };

    case UPDATE_LAW_EXPENSE:
      return {
        ...state,
        expenses: state.expenses.map(expense =>
          expense._id === action.payload._id ? action.payload : expense
        ),
        expense: action.payload
      };

    case DELETE_LAW_EXPENSE:
      return {
        ...state,
        expenses: state.expenses.filter(expense => expense._id !== action.payload)
      };

    default:
      return state;
  }
};

export default lawExpenseReducer;
